/** Shares Boost duration presets and item-specific defaults across modal and embedded forms. */
import dayjs from "dayjs";
import {BoostFormValues, BoostLike, isBoostRunning} from "./boostRules";

export const BOOST_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

export interface BoostDurationOption {
   label: string;
   endTs: dayjs.Dayjs;
}

export interface BoostFormItem {
   activeBoost?: (BoostLike & {endTs?: Date | null}) | null;
}

/** Creates the four quick end-time choices from an injectable clock. */
export const boostDurationOptions = (now: dayjs.Dayjs = dayjs()): BoostDurationOption[] => [
   {label: "24 hours", endTs: now.add(24, "hour")},
   {label: "7 days", endTs: now.add(7, "day")},
   {label: "14 days", endTs: now.add(14, "day")},
   {label: "End of month", endTs: now.endOf("month")}
];

/** Hydrates a running Boost or starts from the safe visibility-only defaults. */
export const defaultBoostFormValues = (
   item?: BoostFormItem,
   now: dayjs.Dayjs = dayjs()
): BoostFormValues => {
   const running = isBoostRunning(item?.activeBoost) ? item?.activeBoost : undefined;
   return {
      discountEnabled: !!running?.pricePct,
      pricePct: running?.pricePct ? running.pricePct / 100 : null,
      visibility: running ? running.visibility : true,
      endTs: dayjs(running?.endTs ?? boostDurationOptions(now)[1].endTs).format(BOOST_DATE_TIME_FORMAT)
   };
};
